export const API_SERVER_URL = process.env.REACT_APP_API_SERVER_BASE_URL;
export const WEB_SERVER_URL = process.env.REACT_APP_WEB_SERVER_BASE_URL;
export const API_SERVER_BASE_URL = process.env.REACT_APP_SERVER_BASE_URL;